import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MenuService, MenuId, MenuDef } from '../services/menu.service';
import { MenuItem } from '../models/menu-item';
import { LocalizeService } from '../services/localize.service';
import { CommandHandler } from '../models/command-handler';
import { Util, UserInterface } from '../utils/utils.module';
import { BaseDesc } from '../models/base';
import { ListItem } from './../models/list-item';

@Component({
  selector: 'edx-inline-action-bar',
  styleUrls: ['inline-action-bar.component.scss'],
  templateUrl: 'inline-action-bar.component.html'
})
export class InlineActionBarComponent implements OnInit {
  private _shown = false;
  private showing = true;
  private hiding = false;
  private isOpen: boolean;
  private ui: UserInterface;
  private isOfficeAddin: boolean = Util.Device.bIsOfficeAddin;
  private hasEnabledItems = false;
  private enabledCustomMenuItemCount = 0;
  private menuDef: MenuDef;
  public items: MenuItem[] = [];
  public customItems: MenuItem[] = [];
  public desc: BaseDesc;
  @Input() resid: MenuId;
  @Input() target: CommandHandler;
  @Input('shown')
  set setter(value: boolean) {
    this.showing = value;
    this.hiding = this._shown && value;
    this._shown = value;
    this.isOpen =  false;
  }
  @Input() listItem: ListItem = null;
  @ViewChild('moreMenu') moreMenu: ElementRef<HTMLElement> | undefined;

  constructor(private menuService: MenuService, private localizer: LocalizeService) {
    this.ui = Util.Device.ui;
  }

  ngOnInit(): void {
    this.menuDef = this.menuService.getMenu(this.resid);
    this.initActionItems();
  }

  public updateActionItems(): void {
    this.hasEnabledItems = false;
    for (const menuItem of this.items) {
      menuItem.enabled = true;
      if (this.target.commandEnabled) {
        menuItem.enabled = this.target.commandEnabled(menuItem.cmd);
      }
      if (menuItem.enabled) {
        this.hasEnabledItems = true;
      }
    }
  }

  public initActionItems(): void {
    this.items = [];
    for (const itemDef of this.menuDef.items) {
      const item: MenuItem = new MenuItem(itemDef);
      item.name = this.localizer.getTranslation(item.name);
      item.icon = item.icon;
      if (item.cmd && item.cmd.startsWith('_custom_')) {
        const selectionRights = Util.RestAPI.getRightsForItem(this.listItem);
        const enableFunc = Util.RestAPI.getCustomCommandFunction(item.cmd, 'enable');
        if (!!enableFunc) {
          item.enabled = enableFunc(this.desc, [this.listItem], selectionRights);
          if (item.enabled) {
            this.customItems.push(item);
            this.enabledCustomMenuItemCount++;
          }
        }
      } else {
        item.enabled = true;
        this.items.push(item);
      }
    }
  }

  private itemClick(itemIndex: number, event: Event, isCustomMenuItem?: boolean): void {
    if (isCustomMenuItem && itemIndex >= 0 && itemIndex < this.customItems.length) {
      if (this.target) {
        this.target.doCommand(this.customItems[itemIndex].cmd);
      }
    } else if (itemIndex >= 0 && itemIndex < this.items.length) {
      if (this.target) {
        this.target.doCommand(this.items[itemIndex].cmd);
      }
    }
    setTimeout(()=> {
      Util.Transforms.focusOnElementByClassName('fileitem selected');
    }, 100);
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  private animationComplete(): void {
    if (this.showing) {
      this.showing = false;
    }
    if (this.hiding) {
      this.hiding = false;
    }
  }

  public isShown(): boolean {
    return this.hiding || (this._shown && this.hasEnabledItems);
  }

  private showHideMoreMenu(event: Event): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.moreMenu.nativeElement.setAttribute('isopen', 'true');
    } else {
      this.moreMenu.nativeElement.removeAttribute('isopen');
    }
    event.stopPropagation();
    event.preventDefault();
  }
}
